__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-05-19-1779187015-stable-dev/";